<script>
    import { getPrimaryRoute } from '$lib/util/url';

    import Header from '$lib/components/Header.svelte';
    import PageTransition from '$lib/components/PageTransition.svelte';
    import Footer from '$lib/components/Footer.svelte';
    
    export let data;
</script>

<Header />
<PageTransition url={getPrimaryRoute(data.pathname)}>
    <slot />
</PageTransition>
<Footer />